module.exports = __webpack_public_path__ + "img/miryoku5.c1b88c8a.jpg";